import Backend from 'alto-utils/lib/backend'
import config  from 'app/config'
import auth    from 'app/auth'

export default new Backend(config.backendUrl, auth)
